import { fetcher } from '../../utils/fetch.js';

export default class LoginForPriceApp {
	constructor () {
		this.email_regex = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i;
		this.email = null;
		this.product_id = window.__prodid;
		this.site_settings = window.SiteSettings || {};

		this.selectors = {
			grid: '.js-products-grid',
			products: '.products-grid .products-grid-item',
			product: '.products-grid .products-grid-item[data-prodid]',
			login_for_prices: '.products-grid .products-grid-item .js-login-for-price',
			login_for_price: '.js-login-for-price',
			product_page_login_for_price: '.js-map-remove .js-login-for-price',
			email: '.js-section.js-email',
			email_control: '.js-section.js-email input',
			email_btn: '.js-section.js-email button'
		};

		this.init();
	}

	init() {
		this.bindEmailsEvents();
		if (!this.product_id) {
			this.bindGridEvents();
		}
	}

	bindGridEvents() {
		document.addEventListener('products-grid:render-end', () => {
			this.bindEmailsEvents();
		});
	}

	bindEmailsEvents() {
		const selector = this.product_id ? this.selectors.product_page_login_for_price : this.selectors.login_for_prices;
		const loginForPriceElements = document.querySelectorAll(selector);

		loginForPriceElements.forEach(element => {
			const inputElement = element.querySelector(this.selectors.email_control);
			const btnElement = element.querySelector(this.selectors.email_btn);

			['change', 'keyup', 'paste'].forEach(evt_name => {
				inputElement.addEventListener(evt_name, event => {
					if (event.code ==='Enter') {
						this.priceRequest(element, inputElement, btnElement);
					}
				});
			});

			inputElement.addEventListener('focus', () => {
				element.classList.add('active');
			});

			btnElement.addEventListener('click', event => {
				event.preventDefault();
				this.priceRequest(element, inputElement, btnElement);
			});
		});
	}

	isEmail (value) {
		return /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i.test(value);
	}

	isValid (data) {
		if (!data.g_recaptcha_response.length || !this.isEmail(data.request_email)) {
			return false;
		} else {
			return true;
		}
	}

	priceRequest (element, inputElement, btnElement) {
		const productElement = inputElement.closest(this.selectors.product);
		const product_id = window.__prodid ? window.__prodid : productElement.dataset.prodid;
		let data = {
			request_email: inputElement.value
		};

		if (window.grecaptcha) {
			window.grecaptcha.ready(function () {
				window.grecaptcha.execute(this.site_settings.RECAPTCHA_SITE_KEY, {action: 'submit'})
					.then(function (token) {
						data.g_recaptcha_response = token;
						inputElement.setAttribute('disabled', 'disabled');
						btnElement.setAttribute('disabled', 'disabled');
						btnElement.classList.add('progress');
						this.submitRequest(data, product_id, element);
					}.bind(this));
			}.bind(this));
		}
	}

	submitRequest (data, product_id, element) {
		let url = `/my/api/2/product/${product_id}/price-request`;

		if (this.isValid(data)) {
			fetcher(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			}).then(() => {
				element.textContent = 'Thank you! Your pricing information has been sent to your email address.';
			});
		}
	}
}
